// src/authConfig.js
// Update these values from webapp-config.ps1 output
//
// REACT_APP_CLIENT_ID is baked into the bundle at `npm run build` time.
// The fallback below is the real Store Audit app registration (a public
// identifier, not a secret). It exists so a build run without the env var
// still produces a working login - on 10 Sep 2026 a placeholder fallback
// shipped to prod and nobody could sign in. See
// Docs/INCIDENT-2026-09-10-prod-login-outage.md. Never put a placeholder here.
const CLIENT_ID = process.env.REACT_APP_CLIENT_ID || "dead1fe3-99f6-404e-a463-e7dc41317dff";

export const msalConfig = {
    auth: {
        clientId: CLIENT_ID,
        authority: "https://login.microsoftonline.com/organizations",
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },
};

export const loginRequest = {
    scopes: ["User.Read"],
};

export const apiRequest = {
    scopes: [`api://${CLIENT_ID}/access_as_user`],
};
